/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const cs_checkout_fail_title = /** @type {(inputs: {}) => string} */ () => {
	return `Platba se nezdařila`
};

const da_checkout_fail_title = /** @type {(inputs: {}) => string} */ () => {
	return `Betalingen mislykkedes`
};

const de_checkout_fail_title = /** @type {(inputs: {}) => string} */ () => {
	return `Zahlung fehlgeschlagen`
};

const en_checkout_fail_title = /** @type {(inputs: {}) => string} */ () => {
	return `The payment failed`
};

const es_checkout_fail_title = /** @type {(inputs: {}) => string} */ () => {
	return `El pago ha fallado`
};

const fr_checkout_fail_title = /** @type {(inputs: {}) => string} */ () => {
	return `Le paiement a échoué`
};

const hu_checkout_fail_title = /** @type {(inputs: {}) => string} */ () => {
	return `A fizetés sikertelen`
};

const it_checkout_fail_title = /** @type {(inputs: {}) => string} */ () => {
	return `Pagamento fallito`
};

const nl_checkout_fail_title = /** @type {(inputs: {}) => string} */ () => {
	return `Betaling mislukt`
};

const pl_checkout_fail_title = /** @type {(inputs: {}) => string} */ () => {
	return `Płatność nie powiodła się`
};

const pt_checkout_fail_title = /** @type {(inputs: {}) => string} */ () => {
	return `O pagamento falhou`
};

const sv_checkout_fail_title = /** @type {(inputs: {}) => string} */ () => {
	return `Betalningen misslyckades`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "cs" | "da" | "de" | "en" | "es" | "fr" | "hu" | "it" | "nl" | "pl" | "pt" | "sv" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
const checkout_fail_title = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.checkout_fail_title(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("checkout_fail_title", locale)
	if (locale === "cs") return cs_checkout_fail_title(inputs)
	if (locale === "da") return da_checkout_fail_title(inputs)
	if (locale === "de") return de_checkout_fail_title(inputs)
	if (locale === "en") return en_checkout_fail_title(inputs)
	if (locale === "es") return es_checkout_fail_title(inputs)
	if (locale === "fr") return fr_checkout_fail_title(inputs)
	if (locale === "hu") return hu_checkout_fail_title(inputs)
	if (locale === "it") return it_checkout_fail_title(inputs)
	if (locale === "nl") return nl_checkout_fail_title(inputs)
	if (locale === "pl") return pl_checkout_fail_title(inputs)
	if (locale === "pt") return pt_checkout_fail_title(inputs)
	return sv_checkout_fail_title(inputs)
};
export { checkout_fail_title as "checkout.fail_title" }